import React from 'react';
import PropTypes from 'prop-types';
import { StaggeredMotion } from 'react-motion';
import { springify } from '../../lib/Motion';
const animatedDestination = springify({ x: 1 }, { stiffness: 60, damping: 15 });
const triggerPoint = 0.5;
const movement = 5;
const scale = 0.25;

class HeadlineAnimator extends React.PureComponent {
  static propTypes = {
    show: PropTypes.bool,
    donePoint: PropTypes.number,
    onDone: PropTypes.func,
    topContent: PropTypes.node,
    middleContent: PropTypes.node,
    bottomContent: PropTypes.node,
  };
  static defaultProps = {
    show: false,
    donePoint: 0.9,
    onDone: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      done: props.show,
      animatedDefault: [{ x: props.show ? 1 : 0 }, { x: props.show ? 1 : 0 }],
    };

    if (props.show) {
      props.onDone();
    }
  }

  markDone = () => {
    if (this.state.done) {
      return;
    }

    this.setState({ done: true });
    this.props.onDone();
  };

  getStyles = prevInterpolatedStyles => {
    return prevInterpolatedStyles.map((style, i) => {
      if (!this.props.show) {
        return style;
      }

      if (i === 0) {
        return animatedDestination;
      }

      if (prevInterpolatedStyles[0].x >= triggerPoint) {
        return animatedDestination;
      }

      return style;
    });
  };

  render() {
    const {
      show,
      donePoint,
      onDone,
      topContent,
      middleContent,
      bottomContent,
      ...otherProps
    } = this.props;

    return (
      <StaggeredMotion
        defaultStyles={this.state.animatedDefault}
        styles={this.getStyles}
      >
        {tweens => {
          const centerStyle = {
            opacity: tweens[0].x,
            transform: `scale(${tweens[0].x * scale + (1 - scale)})`,
          };
          const outerStyle = { opacity: tweens[1].x, position: 'relative' };
          const inverted = tweens[1].x * -1 + 1;
          const topStyle = { ...outerStyle, top: `${inverted * movement}rem` };
          const bottomStyle = {
            ...outerStyle,
            bottom: `${inverted * movement}rem`,
          };

          if (tweens[1].x >= donePoint) {
            setTimeout(this.markDone, 0);
          }

          return (
            <div>
              <div style={topStyle}>{topContent}</div>
              <div style={centerStyle}>{middleContent}</div>
              <div style={bottomStyle}>{bottomContent}</div>
            </div>
          );
        }}
      </StaggeredMotion>
    );
  }
}

export default HeadlineAnimator;



// WEBPACK FOOTER //
// ./src/components/HeadlineAnimator/HeadlineAnimator.js